import { render, staticRenderFns } from "./searchProducts.vue?vue&type=template&id=68a88b39&scoped=true&"
import script from "./searchProducts.vue?vue&type=script&lang=js&"
export * from "./searchProducts.vue?vue&type=script&lang=js&"
import style0 from "./searchProducts.vue?vue&type=style&index=0&id=68a88b39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a88b39",
  null
  
)

export default component.exports